export function getEvents(state) {
  return state.events
}

export function getExpoTenant(state, rootState) {
  return (
    rootState.shared?.settings?.profile_title +
    '-' +
    rootState.shared?.settings?.profile_sub_title
  )
}

export function canPost(state, getters, rootState) {
  return (
    rootState.shared?.settings?.expo_post_count <
    rootState.shared?.settings?.expo_post_cap
  )
}
